import axios from 'axios';
import type { AxiosResponse } from 'axios';
import { HOME_BANNERS_SERVICE_URL } from '../home-banners/constants';
import { HomeBanner, HomeBannerFormValues, HomeBannerListResponse } from './types';

export const createHomeBanner = (
    data: HomeBannerFormValues
): Promise<AxiosResponse<HomeBanner>> => axios.post(HOME_BANNERS_SERVICE_URL, data);

export const getHomeBanners = (): Promise<AxiosResponse<HomeBannerListResponse>> =>
    axios.get(HOME_BANNERS_SERVICE_URL);

export const getHomeBanner = (id: string): Promise<AxiosResponse<HomeBanner>> =>
    axios.get(HOME_BANNERS_SERVICE_URL, {
        params: { id },
    });

export const updateHomeBanner = (
    id: string,
    data: HomeBannerFormValues
): Promise<AxiosResponse<HomeBanner>> =>
    axios.put(HOME_BANNERS_SERVICE_URL, data, {
        params: { id },
    });

export const deleteHomeBanner = (id: string): Promise<AxiosResponse<void>> =>
    axios.delete(HOME_BANNERS_SERVICE_URL, {
        params: { id },
    });
